import {
  activeUploadsSelector,
  completedUploadsSelector,
  failedUploadsSelector,
  pausedUploadsSelector,
  uploaderIsUploadingSelector,
} from '@air/redux-uploader';

import { pendingImportTasksSelector } from '~/store/tasks/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export type WorkspaceActivityStatus = 'in-progress' | 'paused' | 'error' | 'completed';

export const useWorkspaceActivityStatus = () => {
  const isUploading = useAirSelector(uploaderIsUploadingSelector);
  const activeUploads = useAirSelector(activeUploadsSelector);
  const failedUploads = useAirSelector(failedUploadsSelector);
  const pausedUploads = useAirSelector(pausedUploadsSelector);
  const completedUploads = useAirSelector(completedUploadsSelector);
  const pendingImports = useAirSelector(pendingImportTasksSelector);

  const hasTasks =
    isUploading ||
    failedUploads.length > 0 ||
    pausedUploads.length > 0 ||
    completedUploads.length > 0 ||
    pendingImports.length > 0;

  const hasInProgress = isUploading || pendingImports.length > 0;
  const hasPaused = pausedUploads.length > 0;
  const hasError = failedUploads.length > 0;

  let status: WorkspaceActivityStatus = 'completed';

  if (hasInProgress) {
    status = 'in-progress';
  } else if (hasError) {
    status = 'error';
  } else if (hasPaused) {
    status = 'paused';
  }

  let count = 0;

  if (status === 'in-progress') {
    count = activeUploads.length - pausedUploads.length + pendingImports.length;
  } else if (status === 'error') {
    count = failedUploads.length;
  } else if (status === 'paused') {
    count = pausedUploads.length;
  } else {
    count = completedUploads.length;
  }

  return { hasTasks, status, count };
};
